import styled from 'styled-components';

const Wrapper = styled.div`
  display: block;
`;
Wrapper.displayName = 'Wrapper';

export default Wrapper;
